/** Scroll element to the bottom (for vertical scroll containers) */
export const scrollToBottom = (element: HTMLDivElement | null) => {
  if (!element) return;
  element.scrollTop = element.scrollHeight;
};

/** Check if element is scrolled to the bottom (within 2px tolerance) */
export const isScrolledToBottom = (element: HTMLDivElement | null) => !element ? true : element.scrollHeight - element.clientHeight - element.scrollTop <= 2;

/** Scroll element to the end/right (for horizontal scroll containers) */
export const scrollToEnd = (element: HTMLDivElement | null) => {
  if (!element) return;
  element.scrollLeft = element.scrollWidth;
};

/** Check if element is scrolled to the end/right (within 2px tolerance) */
export const isScrolledToEnd = (element: HTMLDivElement | null) => !element ? true : element.scrollWidth - element.clientWidth - element.scrollLeft <= 2;
